import { SelectableCardImage, SelectableCardRoot, SelectableCardText } from "./SelectableCard.styles";
import { SelectableCardProps } from "./SelectableCard.types";

export default function SelectableCard({ image, label, value, onClick, selected }: SelectableCardProps) {
    return (
        <SelectableCardRoot onClick={onClick ? () => onClick(value) : undefined} selected={selected || false}>
            <SelectableCardImage src={image} />
            <SelectableCardText textAlign="center" variant="body4Strong" color="primary">
                {label}
            </SelectableCardText>
        </SelectableCardRoot>
    );
}
